(function ($) {

	function update_cart_item() {

		let data = JSON.parse($(this).attr('data-cart-update-item'))

		gp_ajax({
			url: ghostpress_params.ajax_url + "&action=cart_update_item",
			type: "post",
			dataType: "json",
			data: data,
			show_loading: true
		})
			.done((response, textStatus, jqXHR) => {
				jQuery(document).trigger('cart_updated')
				jQuery(document).trigger('gp_update_checkout')
			})
	}

	function init_cart_items() {
		// Update cart item
		$('[data-cart-update-item]').off('click').click(update_cart_item)
	}

	// Init cart functions
	$(document).gp_ready(init_cart_items)

})(jQuery);
